import { Link, Routes, Route, Navigate } from "react-router-dom";
import Login from './components/login';
import PrivateRoute from './components/privateRoute';
import PublicRoute from './components/publicRoute';
import Dashboard from './components/dashboard';
import Storages from './helper/storages';
import { ToastContainer, toast } from 'react-toastify';
import LoginVerify from "./components/loginVerify";
import RecoveryPassword from "./components/recoveryPassword";
import RegisterUser from "./components/registerUser";
import RegisterVerify from "./components/registerVerify";
import SaveLocation from "./components/saveLocation";

function App() {
  document.body.dir = 'rtl'
  return (
    <>

      <Routes>
        {/* private route */}
        <Route path='/corporate' element={<PrivateRoute />}>
          <Route path='/corporate/*' element={<Dashboard />} />
          <Route path='/corporate' element={<Navigate to="/corporate/dashboard" replace />} />

          <Route path='/corporate/dashboard' element={<Dashboard />} />
          <Route path='/corporate/dashboard/*' element={<Dashboard />} />
          <Route path='/corporate/*' element={<Navigate to="/corporate/dashboard" replace />} />
          <Route path='/corporate' element={<Navigate to="/corporate/dashboard" replace />} />
        </Route>

        {/* public route */}
        <Route path='/corporate/' element={<PublicRoute />}>
          <Route path='/corporate/login' element={<Login />} />
          <Route path='/corporate/login-verify' element={<LoginVerify />} />
          <Route path='/corporate/save-location/:eCode' element={<SaveLocation />} />
          <Route path='/corporate/recovery-password' element={<RecoveryPassword />} />
          <Route path='/corporate/register' element={<RegisterUser />} />
          <Route path='/corporate/register-verify' element={<RegisterVerify />} />
        </Route>

        <Route path='/*' element={<Navigate to="/corporate" replace />} />

      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </>
  );
}

export default App;
